import { api } from "./api";

// Téléversement par MORCEAUX (demande du propriétaire, 2026-10-20 : « permettre
// un upload illimité »). Le proxy devant le serveur refuse les très gros POST
// d'un seul coup ; on découpe donc le fichier en paquets de 4 Mo envoyés un à
// un, puis le serveur les recolle — AUCUNE limite de taille totale.
// Invisible pour l'utilisateur : même bouton, juste une progression affichée.

const TAILLE_MORCEAU = 4 * 1024 * 1024; // 4 Mo — sous la limite du proxy
export const SEUIL_MORCEAUX = 8 * 1024 * 1024; // au-dessus de 8 Mo → par morceaux

export async function envoyerParMorceaux(file, onProgress) {
  const r = await api.post("/admin/upload-morceaux/debut", { filename: file.name });
  const uploadId = r.data.upload_id;
  const total = Math.ceil(file.size / TAILLE_MORCEAU);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * TAILLE_MORCEAU, (i + 1) * TAILLE_MORCEAU);
    await api.put(`/admin/upload-morceaux/${uploadId}?index=${i}`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  return uploadId;
}
